module.exports = __webpack_public_path__ + "assets/img/product-download.33d22130.svg";